/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_Editor_HintInputs */

const en_wc_home_editor_hint = /** @type {(inputs: Wc_Home_Editor_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to load the editor on this page. Best on a desktop or laptop. Open a local file or start a blank document, then use File → Save to keep a copy on your device.`)
};

/**
* | output |
* | --- |
* | "Click to load the editor on this page. Best on a desktop or laptop. Open a local file or start a blank document, then use File → Save to keep a copy on your ..." |
*
* @param {Wc_Home_Editor_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_editor_hint = /** @type {((inputs?: Wc_Home_Editor_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_Editor_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_editor_hint(inputs)
});
export { wc_home_editor_hint as "wc.home.editor_hint" }